<template>
  <div class="w-full h-full">
    <div class="flex">
      <el-select
        size="small"
        class="mr-10px flex-1"
        placeholder="请选择请选择区域"
        v-model="searchData.areaId"
        clearable
        @change="handleSearch()"
        popper-class="visualization-select-popper"
      >
        <el-option
          v-for="(item, index) in areaList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        placeholder="名称、编码"
        v-model="searchData.keyword"
        size="small"
        clearable
        @keypress.enter.native="handleSearch()"
        class="icon-search__input mb-10px flex-1"
      >
        <i
          slot="append"
          class="el-icon-search cursor-pointer icon-search__input"
          @click="handleSearch()"
        ></i>
      </el-input>
    </div>
    <el-table
      :data="tableData"
      highlight-current-row
      :height="tableHeight"
      ref="tableRef"
      v-loading="tableLoading"
    >
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="路径名称" prop="name" show-overflow-tooltip />
      <el-table-column label="路径编码" prop="code" show-overflow-tooltip />
      <el-table-column label="所属区域" prop="areaName" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span class="text-hex-00bcc8 cursor-pointer" @click="handleDetail(row)">{{
            row.areaName
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @size-change="sizeChange()"
      @current-change="currentChange()"
      :current-page.sync="pageConfig.SkipCount"
      :page-size.sync="pageConfig.MaxResultCount"
      :pager-count="5"
      layout="prev, pager, next"
      :total="total"
      class="text-center"
    ></el-pagination>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { EvacuatePathApi } from '@wiz-api/emergency-management'
import { find } from 'lodash'
import { routeIconList } from '../../../assets/js/componentMethods/escapeRoute'

const evacuatePathApi = new EvacuatePathApi()
const areaApi = new AreaApi()

export default {
  data() {
    return {
      areaList: [],
      tableData: [],
      tableLoading: true,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      searchData: {},
      total: 0,
      metalBimBaseData: {},
      areaId: '',
      sceneId: '',
    }
  },
  async created() {
    await this.getAreaList()
    this.findList()
    window.addEventListener('sendAreaId', this.areaIdChange)
  },
  methods: {
    areaIdChange(e) {
      this.areaId = e.detail.areaId
      this.findList()
    },
    handleDetail(row) {
      const marker = find(routeIconList, { code: row.code })
      if (marker) {
        cloudRender.Engine.player.Native.Camera.moveToPos(marker.pos, 0, 10, 2)
      }
      const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
        detail: {
          row,
          type: 'EscapeRoute',
        },
      })
      window.dispatchEvent(openEvent)
    },
    async findList() {
      this.tableLoading = false
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      if (this.sceneId) {
        data.sceneId = this.sceneId
      }
      data.areaId = this.searchData.areaId || this.areaId
      this.loading = true
      const [err, res] = await evacuatePathApi.pagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        modelId: this.sceneId,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    handleSearch() {
      this.pageConfig.pageNo = 1
      this.findList()
    },
    // 页码改变
    sizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.findList()
    },
    // 页数改变
    currentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.findList()
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 80px)'
    },
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        this.areaId = data.areaId
        this.sceneId = data.sceneId
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}

::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  padding: 0 4px;
  margin: 0 5px;
  min-width: 24px;
}
</style>
